import { useAlerting, useTranslation } from "src/hooks";
import { EditFields } from "..";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { AlertType } from "src/api/types";

function useValidation(initFields: EditFields) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();

  const validate = (fields: EditFields) => {
    try {
      const { thresholdLower, thresholdUpper, alertType, interval } = fields;

      if (
        thresholdLower === initFields.thresholdLower &&
        thresholdUpper === initFields.thresholdUpper &&
        alertType === initFields.alertType &&
        interval === initFields.interval
      ) {
        throw t("no_change_warning");
      }

      if (alertType === AlertType.FixedThreshold) {
        if (!thresholdLower && !thresholdUpper) {
          throw t("no_threshold_warning");
        }

        if (thresholdLower && thresholdUpper) {
          if (Number(fields.thresholdLower) >= Number(fields.thresholdUpper)) {
            throw t("invalid_threshold_warning");
          }
        }
      }

      if (
        alertType === AlertType.DynamicThreshold &&
        (!interval || Number(interval) <= 0)
      ) {
        throw t("missing_interval_warning");
      }
    } catch (message: any) {
      alerting("warning", message);
      return false;
    }

    return true;
  };

  return { validate };
}

export default useValidation;
